import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { Form, Icon, Input, Button, Select, Row, Col, PageHeader } from "antd";
import Cliente from "../../api/Cliente";

const UsuarioForm = props => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {}, []);

  const { getFieldDecorator } = props.form;

  const handleSubmit = e => {
    e.preventDefault();
    props.form.validateFields(async (err, values) => {
      if (!err) {
        setLoading(true);
        try {
          await Cliente.getCliente().post(
            `${process.env.REACT_APP_API_URL}auth/register`,
            {
              ...values
            }
          );

          props.history.push("/usuarios/listar");
        } catch (err) {
        } finally {
          setLoading(false);
        }
      }
    });
  };

  return (
    <>
      <PageHeader onBack={() => null} title="Agregar usuario" backIcon={null} />

      <Form onSubmit={handleSubmit} className="login-form" autoComplete="off">
        <Row gutter={16}>
          <Col md={8}>
            <Form.Item required label="Nombre" style={{ marginBottom: 0 }} />
            <Form.Item>
              {getFieldDecorator("name", {
                rules: [
                  { required: true, message: "El campo Nombre es requerido" }
                ]
              })(
                <Input
                  prefix={
                    <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  placeholder="Nombre"
                />
              )}
            </Form.Item>
          </Col>

          <Col md={8}>
            <Form.Item required label="Apellidos" style={{ marginBottom: 0 }} />
            <Form.Item>
              {getFieldDecorator("lastname", {
                rules: [
                  { required: true, message: "El campo Apellidos es requerido" }
                ]
              })(
                <Input
                  prefix={
                    <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  placeholder="Apellidos"
                />
              )}
            </Form.Item>
          </Col>

          <Col md={8}>
            <Form.Item required label="Correo" style={{ marginBottom: 0 }} />
            <Form.Item>
              {getFieldDecorator("email", {
                rules: [
                  {
                    type: "email",
                    message: "El campo no es correo valido"
                  },
                  { required: true, message: "El campo Correo es requerido" }
                ]
              })(
                <Input
                  prefix={
                    <Icon type="mail" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  placeholder="Correo"
                />
              )}
            </Form.Item>
          </Col>

          <Col md={8}>
            <Form.Item required label="Password" style={{ marginBottom: 0 }} />
            <Form.Item>
              {getFieldDecorator("password", {
                rules: [
                  { required: true, message: "El campo Password es requerido" }
                ]
              })(
                <Input
                  type="password"
                  prefix={
                    <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  placeholder="Password"
                />
              )}
            </Form.Item>
          </Col>

          <Col md={8}>
            <Form.Item required label="Confirmar" style={{ marginBottom: 0 }} />
            <Form.Item>
              {getFieldDecorator("confirm", {
                rules: [
                  { required: true, message: "El campo Confirmar es requerido" }
                ]
              })(
                <Input
                  type="password"
                  prefix={
                    <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                  }
                  placeholder="Confirmar"
                />
              )}
            </Form.Item>
          </Col>

          <Col md={8}>
            <Form.Item required label="Rol" style={{ marginBottom: 0 }} />
            <Form.Item>
              {getFieldDecorator("type", {
                rules: [
                  { required: true, message: "El campo Rol es requerido" }
                ]
              })(
                <Select
                  optionFilterProp="children"
                  placeholder="Seleccione un Rol"
                >
                  <Select.Option value="gestor">Gestor</Select.Option>
                  <Select.Option value="outreach">Outreach</Select.Option>
                </Select>
              )}
            </Form.Item>
          </Col>
        </Row>

        <Form.Item className="text-center">
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            loading={loading}
          >
            Agregar
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default withRouter(Form.create({ name: "usuario_form" })(UsuarioForm));
